export function authHeader() {
	// return authorization header with jwt token
	let user = JSON.parse(localStorage.getItem("user"));

	if (user && user.token) {
		return { Authorization: `Bearer ${user.token}` };
	} else {
		return {};
	}
}
export function userScopes() {
	let user = JSON.parse(localStorage.getItem("user"));
	return { scopes: user.scopes, username: user.email };
}
export function userHasScope(requiredScopes, everyScope) {
	if (!Array.isArray(requiredScopes)) requiredScopes = [requiredScopes];
	let user = JSON.parse(localStorage.getItem("user"));
	if (!user || !user.hasOwnProperty("scopes")) return false;
	if (!requiredScopes || requiredScopes.length === 0) return true;
	if (everyScope) {
		return requiredScopes.map(s => user.scopes.indexOf(s)).every(s => s !== -1);
	} else {
		return requiredScopes.map(s => user.scopes.indexOf(s)).some(s => s !== -1);
	}
}

export const validateEmail = mail => {
	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
		return true;
	}
	return false;
};
